import React from 'react';
import PropTypes from 'prop-types';

export const NextArrow = props => {
	const { classLabel, onClick, visible } = props;

	return <div className={'slick-arrow slick-next' + (visible ? ' on ' : ' off ') + classLabel} onClick={onClick} />;
};

export const PrevArrow = props => {
	const { classLabel, onClick, visible } = props;

	return <div className={'slick-arrow slick-prev' + (visible ? ' on ' : ' off ') + classLabel} onClick={onClick} />;
};

PrevArrow.propTypes = {
	classLabel: PropTypes.string,
	visible: PropTypes.bool,
	onClick: PropTypes.func
};

NextArrow.propTypes = {
	classLabel: PropTypes.string,
	visible: PropTypes.bool,
	onClick: PropTypes.func
};
